export default __webpack_public_path__ + "static/asd-b1dd39b213bd3f777814ba827f095b42.png";